export default "__VITE_ASSET__DIXYjjgt__"